var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banners.length)?_c('div',{staticClass:"banner-slider"},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.carouselSettings,false),_vm._l((_vm.banners),function(it){return _c('BannerItem',{key:it.id,attrs:{"type":it.code}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }